import {
  Badge,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  ScrollArea,
  Typography,
} from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { DbtCloudDiscoveredProject } from "../../../types";

interface ProjectsEnvironmentsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  projects: DbtCloudDiscoveredProject[];
}

const ProjectsEnvironmentsModal = ({
  open,
  onOpenChange,
  projects,
}: ProjectsEnvironmentsModalProps): JSX.Element => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="al-max-w-2xl">
        <DialogHeader>
          <DialogTitle>Projects and Environments</DialogTitle>
        </DialogHeader>
        <ScrollArea className="al-max-h-[60vh] al-pr-4">
          <Stack direction="column" gap="md">
            {projects.map(project => (
              <div key={project.id} className="al-border al-border-border al-rounded-lg al-p-4">
                <Stack direction="row" justify="between" align="center" className="al-mb-3">
                  <Typography weight="regular" size="sm">
                    {project.name || `Project ${project.id}`}
                  </Typography>
                  <Badge variant="secondary">
                    {project.environments?.length || 0} environment
                    {(project.environments?.length || 0) !== 1 ? "s" : ""}
                  </Badge>
                </Stack>
                {project.environments && project.environments.length > 0 && (
                  <Stack direction="column" gap="xs" className="al-pl-4">
                    {project.environments.map(env => (
                      <Stack
                        key={env.id}
                        direction="row"
                        align="center"
                        gap="sm"
                        className="al-text-muted-foreground"
                      >
                        <div className="al-w-2 al-h-2 al-rounded-full al-bg-muted-foreground" />
                        <Typography size="sm">{env.name || `Environment ${env.id}`}</Typography>
                        {env.environment_type && (
                          <Badge variant="outline" className="al-text-xs">
                            {env.environment_type}
                          </Badge>
                        )}
                      </Stack>
                    ))}
                  </Stack>
                )}
                {(!project.environments || project.environments.length === 0) && (
                  <Typography size="sm" className="al-text-muted-foreground al-pl-4">
                    No deployment environments found
                  </Typography>
                )}
              </div>
            ))}
            {projects.length === 0 && (
              <Typography className="al-text-center al-text-muted-foreground al-py-8">
                No projects found in this account.
              </Typography>
            )}
          </Stack>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default ProjectsEnvironmentsModal;
